"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/goods/v1/portal_common.proto (package spwn.goods.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalGoodsMetadata = exports.PortalGoods = exports.PortalGoodsSelfShippingShippingSettingMadeToStock = exports.PortalGoodsSelfShippingShippingSettingMadeToOrder = exports.PortalGoodsSelfShippingPurchaseInfo = exports.PortalGoodsDigitalPurchaseInfo = exports.PortalGoodsVariantSelfShipping = exports.PortalGoodsVariantDigital = exports.PortalGoodsImage = exports.PortalGoodsSelfShipping = exports.PortalGoodsDigital = exports.PortalGoodsSelfShippingPurchaseStatus = exports.PortalGoodsDigitalPurchaseStatus = exports.PortalGoodsInventoryStatus = exports.PortalGoodsSalesStatus = exports.PortalGoodsType = exports.PortalGoodsDeliveryMethod = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from enum spwn.goods.v1.PortalGoodsDeliveryMethod
 */
var PortalGoodsDeliveryMethod;
(function (PortalGoodsDeliveryMethod) {
    /**
     * @generated from enum value: PORTAL_GOODS_DELIVERY_METHOD_UNSPECIFIED = 0;
     */
    PortalGoodsDeliveryMethod[PortalGoodsDeliveryMethod["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * デジタル
     *
     * @generated from enum value: PORTAL_GOODS_DELIVERY_METHOD_DIGITAL = 1;
     */
    PortalGoodsDeliveryMethod[PortalGoodsDeliveryMethod["DIGITAL"] = 1] = "DIGITAL";
})(PortalGoodsDeliveryMethod || (exports.PortalGoodsDeliveryMethod = PortalGoodsDeliveryMethod = {}));
// Retrieve enum metadata with: proto3.getEnumType(PortalGoodsDeliveryMethod)
protobuf_1.proto3.util.setEnumType(PortalGoodsDeliveryMethod, "spwn.goods.v1.PortalGoodsDeliveryMethod", [
    { no: 0, name: "PORTAL_GOODS_DELIVERY_METHOD_UNSPECIFIED" },
    { no: 1, name: "PORTAL_GOODS_DELIVERY_METHOD_DIGITAL" },
]);
/**
 * @generated from enum spwn.goods.v1.PortalGoodsType
 */
var PortalGoodsType;
(function (PortalGoodsType) {
    /**
     * @generated from enum value: PORTAL_GOODS_TYPE_UNSPECIFIED = 0;
     */
    PortalGoodsType[PortalGoodsType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: PORTAL_GOODS_TYPE_DIGITAL = 1;
     */
    PortalGoodsType[PortalGoodsType["DIGITAL"] = 1] = "DIGITAL";
    /**
     * @generated from enum value: PORTAL_GOODS_TYPE_SELF_SHIPPING = 2;
     */
    PortalGoodsType[PortalGoodsType["SELF_SHIPPING"] = 2] = "SELF_SHIPPING";
})(PortalGoodsType || (exports.PortalGoodsType = PortalGoodsType = {}));
// Retrieve enum metadata with: proto3.getEnumType(PortalGoodsType)
protobuf_1.proto3.util.setEnumType(PortalGoodsType, "spwn.goods.v1.PortalGoodsType", [
    { no: 0, name: "PORTAL_GOODS_TYPE_UNSPECIFIED" },
    { no: 1, name: "PORTAL_GOODS_TYPE_DIGITAL" },
    { no: 2, name: "PORTAL_GOODS_TYPE_SELF_SHIPPING" },
]);
/**
 * @generated from enum spwn.goods.v1.PortalGoodsSalesStatus
 */
var PortalGoodsSalesStatus;
(function (PortalGoodsSalesStatus) {
    /**
     * @generated from enum value: PORTAL_GOODS_SALES_STATUS_UNSPECIFIED = 0;
     */
    PortalGoodsSalesStatus[PortalGoodsSalesStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 販売中
     *
     * @generated from enum value: PORTAL_GOODS_SALES_STATUS_ON_SALE = 1;
     */
    PortalGoodsSalesStatus[PortalGoodsSalesStatus["ON_SALE"] = 1] = "ON_SALE";
    /**
     * 販売開始前
     *
     * @generated from enum value: PORTAL_GOODS_SALES_STATUS_BEFORE_SALE = 2;
     */
    PortalGoodsSalesStatus[PortalGoodsSalesStatus["BEFORE_SALE"] = 2] = "BEFORE_SALE";
    /**
     * 販売期間終了
     *
     * @generated from enum value: PORTAL_GOODS_SALES_STATUS_AFTER_SALE = 3;
     */
    PortalGoodsSalesStatus[PortalGoodsSalesStatus["AFTER_SALE"] = 3] = "AFTER_SALE";
    /**
     * 売切れ
     *
     * @generated from enum value: PORTAL_GOODS_SALES_STATUS_SOLD_OUT = 4;
     */
    PortalGoodsSalesStatus[PortalGoodsSalesStatus["SOLD_OUT"] = 4] = "SOLD_OUT";
})(PortalGoodsSalesStatus || (exports.PortalGoodsSalesStatus = PortalGoodsSalesStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(PortalGoodsSalesStatus)
protobuf_1.proto3.util.setEnumType(PortalGoodsSalesStatus, "spwn.goods.v1.PortalGoodsSalesStatus", [
    { no: 0, name: "PORTAL_GOODS_SALES_STATUS_UNSPECIFIED" },
    { no: 1, name: "PORTAL_GOODS_SALES_STATUS_ON_SALE" },
    { no: 2, name: "PORTAL_GOODS_SALES_STATUS_BEFORE_SALE" },
    { no: 3, name: "PORTAL_GOODS_SALES_STATUS_AFTER_SALE" },
    { no: 4, name: "PORTAL_GOODS_SALES_STATUS_SOLD_OUT" },
]);
/**
 * @generated from enum spwn.goods.v1.PortalGoodsInventoryStatus
 */
var PortalGoodsInventoryStatus;
(function (PortalGoodsInventoryStatus) {
    /**
     * @generated from enum value: PORTAL_GOODS_INVENTORY_STATUS_UNSPECIFIED = 0;
     */
    PortalGoodsInventoryStatus[PortalGoodsInventoryStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 在庫あり
     *
     * @generated from enum value: PORTAL_GOODS_INVENTORY_STATUS_IN_STOCK = 1;
     */
    PortalGoodsInventoryStatus[PortalGoodsInventoryStatus["IN_STOCK"] = 1] = "IN_STOCK";
    /**
     * 在庫なし
     *
     * @generated from enum value: PORTAL_GOODS_INVENTORY_STATUS_OUT_OF_STOCK = 2;
     */
    PortalGoodsInventoryStatus[PortalGoodsInventoryStatus["OUT_OF_STOCK"] = 2] = "OUT_OF_STOCK";
})(PortalGoodsInventoryStatus || (exports.PortalGoodsInventoryStatus = PortalGoodsInventoryStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(PortalGoodsInventoryStatus)
protobuf_1.proto3.util.setEnumType(PortalGoodsInventoryStatus, "spwn.goods.v1.PortalGoodsInventoryStatus", [
    { no: 0, name: "PORTAL_GOODS_INVENTORY_STATUS_UNSPECIFIED" },
    { no: 1, name: "PORTAL_GOODS_INVENTORY_STATUS_IN_STOCK" },
    { no: 2, name: "PORTAL_GOODS_INVENTORY_STATUS_OUT_OF_STOCK" },
]);
/**
 * @generated from enum spwn.goods.v1.PortalGoodsDigitalPurchaseStatus
 */
var PortalGoodsDigitalPurchaseStatus;
(function (PortalGoodsDigitalPurchaseStatus) {
    /**
     * @generated from enum value: PORTAL_GOODS_DIGITAL_PURCHASE_STATUS_UNSPECIFIED = 0;
     */
    PortalGoodsDigitalPurchaseStatus[PortalGoodsDigitalPurchaseStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 未購入
     *
     * @generated from enum value: PORTAL_GOODS_DIGITAL_PURCHASE_STATUS_NOT_PURCHASED = 1;
     */
    PortalGoodsDigitalPurchaseStatus[PortalGoodsDigitalPurchaseStatus["NOT_PURCHASED"] = 1] = "NOT_PURCHASED";
    /**
     * 支払い待ち
     *
     * @generated from enum value: PORTAL_GOODS_DIGITAL_PURCHASE_STATUS_PAYMENT_PENDING = 2;
     */
    PortalGoodsDigitalPurchaseStatus[PortalGoodsDigitalPurchaseStatus["PAYMENT_PENDING"] = 2] = "PAYMENT_PENDING";
    /**
     * 購入済み
     *
     * @generated from enum value: PORTAL_GOODS_DIGITAL_PURCHASE_STATUS_PURCHASED = 3;
     */
    PortalGoodsDigitalPurchaseStatus[PortalGoodsDigitalPurchaseStatus["PURCHASED"] = 3] = "PURCHASED";
})(PortalGoodsDigitalPurchaseStatus || (exports.PortalGoodsDigitalPurchaseStatus = PortalGoodsDigitalPurchaseStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(PortalGoodsDigitalPurchaseStatus)
protobuf_1.proto3.util.setEnumType(PortalGoodsDigitalPurchaseStatus, "spwn.goods.v1.PortalGoodsDigitalPurchaseStatus", [
    { no: 0, name: "PORTAL_GOODS_DIGITAL_PURCHASE_STATUS_UNSPECIFIED" },
    { no: 1, name: "PORTAL_GOODS_DIGITAL_PURCHASE_STATUS_NOT_PURCHASED" },
    { no: 2, name: "PORTAL_GOODS_DIGITAL_PURCHASE_STATUS_PAYMENT_PENDING" },
    { no: 3, name: "PORTAL_GOODS_DIGITAL_PURCHASE_STATUS_PURCHASED" },
]);
/**
 * @generated from enum spwn.goods.v1.PortalGoodsSelfShippingPurchaseStatus
 */
var PortalGoodsSelfShippingPurchaseStatus;
(function (PortalGoodsSelfShippingPurchaseStatus) {
    /**
     * @generated from enum value: PORTAL_GOODS_SELF_SHIPPING_PURCHASE_STATUS_UNSPECIFIED = 0;
     */
    PortalGoodsSelfShippingPurchaseStatus[PortalGoodsSelfShippingPurchaseStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 未購入
     *
     * @generated from enum value: PORTAL_GOODS_SELF_SHIPPING_PURCHASE_STATUS_NOT_PURCHASED = 1;
     */
    PortalGoodsSelfShippingPurchaseStatus[PortalGoodsSelfShippingPurchaseStatus["NOT_PURCHASED"] = 1] = "NOT_PURCHASED";
    /**
     * 支払い待ち
     *
     * @generated from enum value: PORTAL_GOODS_SELF_SHIPPING_PURCHASE_STATUS_PAYMENT_PENDING = 2;
     */
    PortalGoodsSelfShippingPurchaseStatus[PortalGoodsSelfShippingPurchaseStatus["PAYMENT_PENDING"] = 2] = "PAYMENT_PENDING";
    /**
     * 購入済み
     *
     * @generated from enum value: PORTAL_GOODS_SELF_SHIPPING_PURCHASE_STATUS_PURCHASED = 3;
     */
    PortalGoodsSelfShippingPurchaseStatus[PortalGoodsSelfShippingPurchaseStatus["PURCHASED"] = 3] = "PURCHASED";
})(PortalGoodsSelfShippingPurchaseStatus || (exports.PortalGoodsSelfShippingPurchaseStatus = PortalGoodsSelfShippingPurchaseStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(PortalGoodsSelfShippingPurchaseStatus)
protobuf_1.proto3.util.setEnumType(PortalGoodsSelfShippingPurchaseStatus, "spwn.goods.v1.PortalGoodsSelfShippingPurchaseStatus", [
    { no: 0, name: "PORTAL_GOODS_SELF_SHIPPING_PURCHASE_STATUS_UNSPECIFIED" },
    { no: 1, name: "PORTAL_GOODS_SELF_SHIPPING_PURCHASE_STATUS_NOT_PURCHASED" },
    { no: 2, name: "PORTAL_GOODS_SELF_SHIPPING_PURCHASE_STATUS_PAYMENT_PENDING" },
    { no: 3, name: "PORTAL_GOODS_SELF_SHIPPING_PURCHASE_STATUS_PURCHASED" },
]);
/**
 * @generated from message spwn.goods.v1.PortalGoodsDigital
 */
class PortalGoodsDigital extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * グッズ名
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * 説明
         *
         * @generated from field: string body = 3;
         */
        this.body = "";
        /**
         * 価格
         *
         * @generated from field: double price = 4;
         */
        this.price = 0;
        /**
         * 画像
         *
         * @generated from field: repeated spwn.goods.v1.PortalGoodsImage images = 5;
         */
        this.images = [];
        /**
         * バリエーション
         * 必ず1つ以上のバリエーションが存在する
         *
         * @generated from field: repeated spwn.goods.v1.PortalGoodsVariantDigital variants = 6;
         */
        this.variants = [];
        /**
         * 並び順（降順）
         *
         * @generated from field: int32 priority = 7;
         */
        this.priority = 0;
        /**
         * 販売状況
         *
         * @generated from field: spwn.goods.v1.PortalGoodsSalesStatus sales_status = 8;
         */
        this.salesStatus = PortalGoodsSalesStatus.UNSPECIFIED;
        /**
         * 種別
         *
         * @generated from field: spwn.goods.v1.PortalGoodsType type = 11;
         */
        this.type = PortalGoodsType.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalGoodsDigital().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalGoodsDigital().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalGoodsDigital().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalGoodsDigital, a, b);
    }
}
exports.PortalGoodsDigital = PortalGoodsDigital;
PortalGoodsDigital.runtime = protobuf_1.proto3;
PortalGoodsDigital.typeName = "spwn.goods.v1.PortalGoodsDigital";
PortalGoodsDigital.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "images", kind: "message", T: PortalGoodsImage, repeated: true },
    { no: 6, name: "variants", kind: "message", T: PortalGoodsVariantDigital, repeated: true },
    { no: 7, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "sales_status", kind: "enum", T: protobuf_1.proto3.getEnumType(PortalGoodsSalesStatus) },
    { no: 9, name: "sales_period_started_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 10, name: "sales_period_ended_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 11, name: "type", kind: "enum", T: protobuf_1.proto3.getEnumType(PortalGoodsType) },
]);
/**
 * @generated from message spwn.goods.v1.PortalGoodsSelfShipping
 */
class PortalGoodsSelfShipping extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * グッズ名
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * 説明
         *
         * @generated from field: string body = 3;
         */
        this.body = "";
        /**
         * 価格
         *
         * @generated from field: double price = 4;
         */
        this.price = 0;
        /**
         * 画像
         *
         * @generated from field: repeated spwn.goods.v1.PortalGoodsImage images = 5;
         */
        this.images = [];
        /**
         * バリエーション
         * 必ず1つ以上のバリエーションが存在する
         *
         * @generated from field: repeated spwn.goods.v1.PortalGoodsVariantSelfShipping variants = 6;
         */
        this.variants = [];
        /**
         * 並び順（降順）
         *
         * @generated from field: int32 priority = 7;
         */
        this.priority = 0;
        /**
         * 販売状況
         *
         * @generated from field: spwn.goods.v1.PortalGoodsSalesStatus sales_status = 8;
         */
        this.salesStatus = PortalGoodsSalesStatus.UNSPECIFIED;
        /**
         * 種別
         *
         * @generated from field: spwn.goods.v1.PortalGoodsType type = 11;
         */
        this.type = PortalGoodsType.UNSPECIFIED;
        /**
         * 発送設定
         *
         * @generated from oneof spwn.goods.v1.PortalGoodsSelfShipping.shipping_setting
         */
        this.shippingSetting = { case: undefined };
        /**
         * 受注販売商品
         *
         * @generated from field: bool is_built_to_order = 14;
         */
        this.isBuiltToOrder = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalGoodsSelfShipping().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalGoodsSelfShipping().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalGoodsSelfShipping().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalGoodsSelfShipping, a, b);
    }
}
exports.PortalGoodsSelfShipping = PortalGoodsSelfShipping;
PortalGoodsSelfShipping.runtime = protobuf_1.proto3;
PortalGoodsSelfShipping.typeName = "spwn.goods.v1.PortalGoodsSelfShipping";
PortalGoodsSelfShipping.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "images", kind: "message", T: PortalGoodsImage, repeated: true },
    { no: 6, name: "variants", kind: "message", T: PortalGoodsVariantSelfShipping, repeated: true },
    { no: 7, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "sales_status", kind: "enum", T: protobuf_1.proto3.getEnumType(PortalGoodsSalesStatus) },
    { no: 9, name: "sales_period_started_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 10, name: "sales_period_ended_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 11, name: "type", kind: "enum", T: protobuf_1.proto3.getEnumType(PortalGoodsType) },
    { no: 12, name: "made_to_order", kind: "message", T: PortalGoodsSelfShippingShippingSettingMadeToOrder, oneof: "shipping_setting" },
    { no: 13, name: "made_to_stock", kind: "message", T: PortalGoodsSelfShippingShippingSettingMadeToStock, oneof: "shipping_setting" },
    { no: 14, name: "is_built_to_order", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.goods.v1.PortalGoodsImage
 */
class PortalGoodsImage extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 画像のURL
         *
         * @generated from field: string src = 2;
         */
        this.src = "";
        /**
         * 並び順（降順）
         *
         * @generated from field: int32 position = 3;
         */
        this.position = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalGoodsImage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalGoodsImage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalGoodsImage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalGoodsImage, a, b);
    }
}
exports.PortalGoodsImage = PortalGoodsImage;
PortalGoodsImage.runtime = protobuf_1.proto3;
PortalGoodsImage.typeName = "spwn.goods.v1.PortalGoodsImage";
PortalGoodsImage.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 2, name: "src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.goods.v1.PortalGoodsVariantDigital
 */
class PortalGoodsVariantDigital extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_variant_id = 1;
         */
        this.goodsVariantId = "";
        /**
         * バリエーション名
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * 並び順 1から昇順
         *
         * @generated from field: int32 position = 4;
         */
        this.position = 0;
        /**
         * 在庫状況
         *
         * @generated from field: spwn.goods.v1.PortalGoodsInventoryStatus inventory_status = 5;
         */
        this.inventoryStatus = PortalGoodsInventoryStatus.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalGoodsVariantDigital().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalGoodsVariantDigital().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalGoodsVariantDigital().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalGoodsVariantDigital, a, b);
    }
}
exports.PortalGoodsVariantDigital = PortalGoodsVariantDigital;
PortalGoodsVariantDigital.runtime = protobuf_1.proto3;
PortalGoodsVariantDigital.typeName = "spwn.goods.v1.PortalGoodsVariantDigital";
PortalGoodsVariantDigital.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "image", kind: "message", T: PortalGoodsImage },
    { no: 4, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "inventory_status", kind: "enum", T: protobuf_1.proto3.getEnumType(PortalGoodsInventoryStatus) },
    { no: 6, name: "purchase_info", kind: "message", T: PortalGoodsDigitalPurchaseInfo },
]);
/**
 * @generated from message spwn.goods.v1.PortalGoodsVariantSelfShipping
 */
class PortalGoodsVariantSelfShipping extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_variant_id = 1;
         */
        this.goodsVariantId = "";
        /**
         * バリエーション名
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * 並び順 1から昇順
         *
         * @generated from field: int32 position = 4;
         */
        this.position = 0;
        /**
         * 在庫状況
         *
         * @generated from field: spwn.goods.v1.PortalGoodsInventoryStatus inventory_status = 5;
         */
        this.inventoryStatus = PortalGoodsInventoryStatus.UNSPECIFIED;
        /**
         * 在庫数
         *
         * @generated from field: int32 inventory_quantity = 6;
         */
        this.inventoryQuantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalGoodsVariantSelfShipping().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalGoodsVariantSelfShipping().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalGoodsVariantSelfShipping().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalGoodsVariantSelfShipping, a, b);
    }
}
exports.PortalGoodsVariantSelfShipping = PortalGoodsVariantSelfShipping;
PortalGoodsVariantSelfShipping.runtime = protobuf_1.proto3;
PortalGoodsVariantSelfShipping.typeName = "spwn.goods.v1.PortalGoodsVariantSelfShipping";
PortalGoodsVariantSelfShipping.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "image", kind: "message", T: PortalGoodsImage },
    { no: 4, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "inventory_status", kind: "enum", T: protobuf_1.proto3.getEnumType(PortalGoodsInventoryStatus) },
    { no: 6, name: "inventory_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "purchase_info", kind: "message", T: PortalGoodsSelfShippingPurchaseInfo },
]);
/**
 * @generated from message spwn.goods.v1.PortalGoodsDigitalPurchaseInfo
 */
class PortalGoodsDigitalPurchaseInfo extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.goods.v1.PortalGoodsDigitalPurchaseStatus purchase_status = 1;
         */
        this.purchaseStatus = PortalGoodsDigitalPurchaseStatus.UNSPECIFIED;
        /**
         * @generated from field: string download_url = 2;
         */
        this.downloadUrl = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalGoodsDigitalPurchaseInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalGoodsDigitalPurchaseInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalGoodsDigitalPurchaseInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalGoodsDigitalPurchaseInfo, a, b);
    }
}
exports.PortalGoodsDigitalPurchaseInfo = PortalGoodsDigitalPurchaseInfo;
PortalGoodsDigitalPurchaseInfo.runtime = protobuf_1.proto3;
PortalGoodsDigitalPurchaseInfo.typeName = "spwn.goods.v1.PortalGoodsDigitalPurchaseInfo";
PortalGoodsDigitalPurchaseInfo.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "purchase_status", kind: "enum", T: protobuf_1.proto3.getEnumType(PortalGoodsDigitalPurchaseStatus) },
    { no: 2, name: "download_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.PortalGoodsSelfShippingPurchaseInfo
 */
class PortalGoodsSelfShippingPurchaseInfo extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.goods.v1.PortalGoodsSelfShippingPurchaseStatus purchase_status = 1;
         */
        this.purchaseStatus = PortalGoodsSelfShippingPurchaseStatus.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalGoodsSelfShippingPurchaseInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalGoodsSelfShippingPurchaseInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalGoodsSelfShippingPurchaseInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalGoodsSelfShippingPurchaseInfo, a, b);
    }
}
exports.PortalGoodsSelfShippingPurchaseInfo = PortalGoodsSelfShippingPurchaseInfo;
PortalGoodsSelfShippingPurchaseInfo.runtime = protobuf_1.proto3;
PortalGoodsSelfShippingPurchaseInfo.typeName = "spwn.goods.v1.PortalGoodsSelfShippingPurchaseInfo";
PortalGoodsSelfShippingPurchaseInfo.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "purchase_status", kind: "enum", T: protobuf_1.proto3.getEnumType(PortalGoodsSelfShippingPurchaseStatus) },
]);
/**
 * 受注生産の発送設定
 *
 * @generated from message spwn.goods.v1.PortalGoodsSelfShippingShippingSettingMadeToOrder
 */
class PortalGoodsSelfShippingShippingSettingMadeToOrder extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 送料
         *
         * @generated from field: double shipping_fee = 1;
         */
        this.shippingFee = 0;
        /**
         * 発送予定日
         *
         * @generated from field: int64 shipped_at = 2;
         */
        this.shippedAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalGoodsSelfShippingShippingSettingMadeToOrder().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalGoodsSelfShippingShippingSettingMadeToOrder().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalGoodsSelfShippingShippingSettingMadeToOrder().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalGoodsSelfShippingShippingSettingMadeToOrder, a, b);
    }
}
exports.PortalGoodsSelfShippingShippingSettingMadeToOrder = PortalGoodsSelfShippingShippingSettingMadeToOrder;
PortalGoodsSelfShippingShippingSettingMadeToOrder.runtime = protobuf_1.proto3;
PortalGoodsSelfShippingShippingSettingMadeToOrder.typeName = "spwn.goods.v1.PortalGoodsSelfShippingShippingSettingMadeToOrder";
PortalGoodsSelfShippingShippingSettingMadeToOrder.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "shipping_fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "shipped_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * 見込み生産の発送設定
 *
 * @generated from message spwn.goods.v1.PortalGoodsSelfShippingShippingSettingMadeToStock
 */
class PortalGoodsSelfShippingShippingSettingMadeToStock extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 送料
         *
         * @generated from field: double shipping_fee = 1;
         */
        this.shippingFee = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalGoodsSelfShippingShippingSettingMadeToStock().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalGoodsSelfShippingShippingSettingMadeToStock().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalGoodsSelfShippingShippingSettingMadeToStock().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalGoodsSelfShippingShippingSettingMadeToStock, a, b);
    }
}
exports.PortalGoodsSelfShippingShippingSettingMadeToStock = PortalGoodsSelfShippingShippingSettingMadeToStock;
PortalGoodsSelfShippingShippingSettingMadeToStock.runtime = protobuf_1.proto3;
PortalGoodsSelfShippingShippingSettingMadeToStock.typeName = "spwn.goods.v1.PortalGoodsSelfShippingShippingSettingMadeToStock";
PortalGoodsSelfShippingShippingSettingMadeToStock.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "shipping_fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "min_days_to_ship", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "max_days_to_ship", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.goods.v1.PortalGoods
 */
class PortalGoods extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof spwn.goods.v1.PortalGoods.data
         */
        this.data = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalGoods().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalGoods().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalGoods().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalGoods, a, b);
    }
}
exports.PortalGoods = PortalGoods;
PortalGoods.runtime = protobuf_1.proto3;
PortalGoods.typeName = "spwn.goods.v1.PortalGoods";
PortalGoods.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "digital", kind: "message", T: PortalGoodsDigital, oneof: "data" },
    { no: 2, name: "self_shipping", kind: "message", T: PortalGoodsSelfShipping, oneof: "data" },
]);
/**
 * @generated from message spwn.goods.v1.PortalGoodsMetadata
 */
class PortalGoodsMetadata extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * グッズID
         *
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * グッズ名
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * 説明
         *
         * @generated from field: string body = 3;
         */
        this.body = "";
        /**
         * 価格
         *
         * @generated from field: double price = 4;
         */
        this.price = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalGoodsMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalGoodsMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalGoodsMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalGoodsMetadata, a, b);
    }
}
exports.PortalGoodsMetadata = PortalGoodsMetadata;
PortalGoodsMetadata.runtime = protobuf_1.proto3;
PortalGoodsMetadata.typeName = "spwn.goods.v1.PortalGoodsMetadata";
PortalGoodsMetadata.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "thumbnail", kind: "message", T: PortalGoodsImage },
]);
//# sourceMappingURL=portal_common_pb.js.map